import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  email: string = '';
  password: string = '';
  constructor(public authService: AuthService) {}

  ngOnInit(): void {}
  signUp = () => {
    this.authService.signUp(this.email, this.password);
  };
  signIn = () => {
    console.log('signin');
  };
}
